import { Component, ChangeDetectionStrategy } from "@angular/core";
import { HeaderComponent } from "../../../header/header.component";
import { ButtonComponent } from "../../../button/button.component";

@Component({
    selector: "rask-showroom-rask-button",
    templateUrl: "./showroom-rask-button.component.html",
    styleUrls: ["./showroom-rask-button.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HeaderComponent,
        ButtonComponent
    ]
})
export class ShowroomRaskButtonComponent {

}
